var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "list-group" },
    [
      _c("api-errors", { attrs: { errors: _vm.allErrors } }),
      _vm._v(" "),
      _vm._l(
        _vm.listOfMetadataRepresentations,
        function (metadataRepresentation, metadataRepIndex) {
          return _c(
            "div",
            { key: metadataRepIndex, staticClass: "list-group-item" },
            [
              _c(
                "h2",
                {
                  staticClass: "list-group-item-heading",
                  attrs: { id: metadataRepresentation.name_plural },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(metadataRepresentation.name_plural) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._l(metadataRepresentation.mapping, function (elem, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "list-group-item-text pb-10" },
                  [
                    elem.is_existing
                      ? _c("i", {
                          staticClass: "fas fa-edit aristotle-green",
                          attrs: {
                            title: `${elem.name} is an existing item and will be updated.`,
                          },
                        })
                      : elem.recently_created
                      ? _c("i", {
                          staticClass: "fa fa-check aristotle-green",
                          attrs: {
                            title: `This ${metadataRepresentation.name_singular} has been successfully saved`,
                          },
                        })
                      : _c("i", {
                          staticClass:
                            "fad fa-plus-square aristotle-font-awesome-duotone",
                          attrs: {
                            title: `This ${metadataRepresentation.name_singular} will be created`,
                          },
                        }),
                    _vm._v(" "),
                    elem.is_existing || elem.recently_created
                      ? _c(
                          "strong",
                          { attrs: { id: _vm.getElementId(elem.name, index) } },
                          [
                            _c(
                              "a",
                              { attrs: { href: elem.url, target: "_blank" } },
                              [_vm._v(_vm._s(elem.name))]
                            ),
                          ]
                        )
                      : _c(
                          "strong",
                          { attrs: { id: _vm.getElementId(elem.name, index) } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(elem.name) +
                                "\n            "
                            ),
                          ]
                        ),
                    _vm._v(" "),
                    elem.fields.uuid && _vm.fileIsLoaded
                      ? _c("div", [
                          elem.fields.uuid.workgroup.id !==
                            _vm.selectedWorkGroup && _vm.selectedWorkGroup
                            ? _c("div", { staticClass: "alert alert-info" }, [
                                elem.fields.uuid.workgroup.id === "noWorkgroup"
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                        This item will be added to "
                                      ),
                                      _c("em", [
                                        _vm._v(_vm._s(_vm.workgroupName)),
                                      ]),
                                    ])
                                  : _c("div", [
                                      _vm._v(
                                        "\n                        This item will be moved from "
                                      ),
                                      _c("em", [
                                        _vm._v(
                                          _vm._s(
                                            elem.fields.uuid.workgroup.name
                                          )
                                        ),
                                      ]),
                                      _vm._v(" to "),
                                      _c("em", [
                                        _vm._v(_vm._s(_vm.workgroupName)),
                                      ]),
                                    ]),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "list-group-item-text fields-table" },
                      _vm._l(
                        elem.fields,
                        function (fieldValue, fieldName, fieldIndex) {
                          return _c(
                            "li",
                            { key: fieldIndex, staticClass: "mt-10" },
                            [
                              fieldName === "permissiblevalue_set" ||
                              fieldName === "supplementaryvalue_set"
                                ? _c(
                                    "div",
                                    [
                                      _c("abstract-value-representation", {
                                        attrs: {
                                          "value-name": fieldName,
                                          contents: fieldValue,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : fieldValue.is_existing
                                ? _c("div", [
                                    _c("em", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getMetadataTypeNameSingular(
                                            fieldName
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _c("i", {
                                        staticClass:
                                          "fas fa-link aristotle-green",
                                        attrs: {
                                          title: `${fieldValue.name} is an existing item.`,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: fieldValue.url,
                                            target: "_blank",
                                          },
                                        },
                                        [_vm._v(_vm._s(fieldValue.name))]
                                      ),
                                    ]),
                                  ])
                                : _vm.metadataNamesMappingSingular.has(
                                    fieldName
                                  )
                                ? _c("div", [
                                    _c("em", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getMetadataTypeNameSingular(
                                            fieldName
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      { attrs: { href: `#${fieldValue}0` } },
                                      [_vm._v(_vm._s(fieldValue))]
                                    ),
                                  ])
                                : fieldValue.is_url
                                ? _c("div", [
                                    _c("em", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.camelCaseToSentenceCase(fieldName)
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: fieldValue.url,
                                            target: "_blank",
                                          },
                                        },
                                        [_vm._v(_vm._s(fieldValue.url))]
                                      ),
                                    ]),
                                  ])
                                : fieldName === "customvalue_set"
                                ? _c("div", [
                                    _c("em", [_vm._v("Custom Values")]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "container" }, [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-striped customvalue-table",
                                        },
                                        [
                                          _vm._m(0, true),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              fieldValue,
                                              function (
                                                value,
                                                key,
                                                fieldValueIndex
                                              ) {
                                                return _c(
                                                  "tr",
                                                  { key: fieldValueIndex },
                                                  [
                                                    _c("td", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.getNameFromSystemName(
                                                              key
                                                            )
                                                          )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(" " + _vm._s(key)),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        " " + _vm._s(value)
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ])
                                : fieldName === "identifiers"
                                ? _c("div", [
                                    _c("em", [_vm._v("Identifiers")]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "container" }, [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-striped customvalue-table",
                                        },
                                        [
                                          _vm._m(1, true),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              fieldValue,
                                              function (
                                                value,
                                                key,
                                                fieldValueIndex
                                              ) {
                                                return _c(
                                                  "tr",
                                                  { key: fieldValueIndex },
                                                  [
                                                    _c("td", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: _vm.getUrlFromNamespaceIdNameMappingList(
                                                              value.namespace
                                                            ),
                                                            target: "_blank",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getNameFromNamespaceIdNameMappingList(
                                                                value.namespace
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            value.identifier
                                                          )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(value.version)
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ])
                                : fieldName === "alternative_names"
                                ? _c("div", [
                                    _c("em", [_vm._v("Alternative Names")]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "container" }, [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-striped customvalue-table",
                                        },
                                        [
                                          _vm._m(2, true),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              fieldValue,
                                              function (
                                                value,
                                                key,
                                                fieldValueIndex
                                              ) {
                                                return _c(
                                                  "tr",
                                                  { key: fieldValueIndex },
                                                  [
                                                    _c("td", [
                                                      _vm._v(" " + _vm._s(key)),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        " " + _vm._s(value)
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ])
                                : _c("div", [
                                    _c("em", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.camelCaseToSentenceCase(fieldName)
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(fieldValue))]),
                                  ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]
                )
              }),
            ],
            2
          )
        }
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("System Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Content")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Namespace")]),
        _vm._v(" "),
        _c("th", [_vm._v("Identifier")]),
        _vm._v(" "),
        _c("th", [_vm._v("Version")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Alternative Name Type")]),
        _vm._v(" "),
        _c("th", [_vm._v("Alternative Name")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }